import { Navigate, useParams } from "react-router-dom";

function ViewOrder() {
  const { id } = useParams();
  if (!id) {
    return null;
  }

  return <Navigate replace to={`/orders/details/${id}`} />;
}

export default ViewOrder;
